// This is an abstract card generator component based on the information it receives from the component that calls it


import Card from 'react-bootstrap/Card';
import './ServiceCard.css';

const ServiceCard = (props) =>{
    return(
        <Card className="card-wrapper">
            <Card.Img src={props.pic} className="card-img"/>
            <Card.Body>
                <Card.Title className="card-title">{props.title}</Card.Title>
            </Card.Body>
        </Card>
    )
}

export default ServiceCard;